<template>
  <div class="spinning-wheel-rewards-report">
    <div class="category-top-bar sticky-header">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click.prevent="back">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <div class="text-right">
          <h5 class="mar-bt-0">{{ pageTitle }}</h5>
        </div>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>

        <el-table
          :data="tableData"
          :empty-text="$t('gestiune.noData')"
          style="width: 100%;"
          @row-click="onRowClick"
        >
          <el-table-column prop="id" :label="$t('customers.id')" width="70" />
          <el-table-column prop="name" :label="$t('spinningWheel.reward')" min-width="160" show-overflow-tooltip />
          <el-table-column prop="type" :label="$t('spinningWheel.rewardType')" width="140" />
          <el-table-column :label="$t('spinningWheel.winningPercentage')" width="120">
            <template slot-scope="props">{{ props.row.winning_percentage }}%</template>
          </el-table-column>
          <el-table-column prop="wins" :label="$t('spinningWheel.wins')" width="90" />
          <el-table-column prop="users_who_won" :label="$t('spinningWheel.usersWhoWon')" width="120" />
          <el-table-column prop="redeemed" :label="$t('spinningWheel.redeemed')" width="100" />
          <el-table-column prop="remaining" :label="$t('spinningWheel.remaining')" width="100" />
          <el-table-column :label="$t('spinningWheel.redemptionRate')" width="120">
            <template slot-scope="props">
              {{ props.row.redemption_rate != null ? props.row.redemption_rate + '%' : '—' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Table, TableColumn } from 'element-ui'

Vue.use(Table)
Vue.use(TableColumn)

export default {
  props: {
    route: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      campaignId: null,
      pageTitle: ''
    }
  },
  created () {
    this.campaignId = (this.route.params && this.route.params.campaignId) ||
      (this.$route.params && this.$route.params.campaignId)
    this.pageTitle = (this.$route.query && this.$route.query.title) || this.$t('spinningWheel.rewards')
    this.loadReport()
  },
  methods: {
    back () {
      this.$bus.$emit('refresh-spinning-wheel-report')
      this.$bus.$emit('close-modal')
    },
    loadReport () {
      if (!this.campaignId) return
      this.loading = true
      const params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      const q = this.$route.query || {}
      if (q.date_from) params.date_from = q.date_from
      if (q.date_to) params.date_to = q.date_to
      this.apiRequest('/reports/spinning-wheel/' + this.campaignId + '/rewards', 'GET', params, (response) => {
        this.loading = false
        if (response.status && response.data) {
          this.tableData = response.data.rewards || []
          if (response.data.campaign && response.data.campaign.title) {
            this.pageTitle = response.data.campaign.title
          }
        } else {
          this.tableData = []
        }
      })
    },
    onRowClick (row) {
      if (!row || !row.id) return
      const q = this.$route.query || {}
      this.$router.push({
        path: '/reports/spinning-wheel/rewards/' + row.id + '/users',
        query: {
          title: row.name || ('#' + row.id),
          date_from: q.date_from || '',
          date_to: q.date_to || '',
          campaign_id: this.campaignId
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/SpinningWheelRewardsReport.vue